module.exports = __webpack_public_path__ + "img/mob-skills.fcd80d92.svg";